/* PROJECTS */
export const GET_ALL_CLASSIFICATIONS = "GET_CLASSIFICATIONS"
export const GET_ALL_CLASSIFICATIONS_SUCCESS = "GET_CLASSIFICATIONS_SUCCESS"
export const GET_ALL_CLASSIFICATIONS_FAIL = "GET_CLASSIFICATIONS_FAIL"
